import axios from "axios";
import { Formik } from "formik";
import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { setCredentials } from "../../redux/slices/authSlice";
import {  ButtonAuth, InputAuth } from "../../components/auth";
import {
  createPasswordInitialValues as initialValues,
  CreatePasswordSchema as validationSchema,
} from "./helper";

const CreatePassword = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [param] = useSearchParams();
  const uid = param.get("uid");
  const dispatch = useDispatch();

  useEffect(() => {
    if (!uid) {
      toast.error("Identifiant manquant dans l’URL.");
      navigate("/signup");
    }
  }, [uid, navigate]);

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/auth/set-password`,
        {
          uid: uid,
          password: values.password,
          first_name: values.first_name,
          last_name: values.last_name,
        },
        {
          withCredentials: true,
        }
      );

      const { access_token, user_info } = res.data;

      dispatch(
        setCredentials({
          accessToken: access_token,
          userInfo: user_info,
        })
      );

      toast.success("Compte activé avec succès !");
      // navigate("/pricing");
      navigate("/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Erreur serveur");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>
          {t("set-password", "Définir son mot de passe")} | BotBlogR
        </title>
        <meta
          name="description"
          content="Définissez votre mot de passe pour activer votre compte."
        />
      </Helmet>

      <Formik
        initialValues={initialValues}
        enableReinitialize={true}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(props) => (
          <form onSubmit={props.handleSubmit} className="space-y-6">
            <InputAuth
              formikProps={props}
              type="text"
              text={t("first-name", "Prénom")}
              name="first_name"
              placeholder={t("enter-first-name", "Entrez votre prénom")}
            />

            <InputAuth
              formikProps={props}
              type="text"
              text={t("last-name", "Nom de famille")}
              name="last_name"
              placeholder={t("enter-last-name", "Entrez votre nom")}
            />

            <InputAuth
              formikProps={props}
              type="password"
              text={t("password", "Mot de passe")}
              name="password"
              placeholder={t("enter-password", "Entrez votre mot de passe")}
            />

            <InputAuth
              formikProps={props}
              type="password"
              text={t("confirm-password", "Confirmer le mot de passe")}
              name="confirm_password"
              placeholder={t(
                "confirm-password-placeholder",
                "Confirme ton mot de passe"
              )}
            />

            <ButtonAuth
              action={props.handleSubmit}
              disabled={props.isSubmitting}
              isLoading={props.isSubmitting}
              type="submit"
              text={t("validate", "Valider")}
            />
          </form>
        )}
      </Formik>
    </>
  );
};

export default CreatePassword;
